// ============================================================
// LaterThanEstimateDot.tsx — a small, calm amber dot beside a SAVED
// limitation date that is later than Casevo's estimate (B2b fix;
// utils/limitationRules deadlineLaterThanEstimate). The full sentence is its
// tooltip and accessible label. Used by the case hero and the quick view.
// ============================================================
import React from 'react'

const LaterThanEstimateDot: React.FC<{ message: string; className?: string }> = ({ message, className }) => (
  <span
    role="img"
    aria-label={message}
    title={message}
    className={`inline-block shrink-0 w-[8px] h-[8px] rounded-full align-middle ${className ?? 'bg-casevo-warn'}`}
  />
)

export default LaterThanEstimateDot
